
import { setPlanningShiftTableLoading } from '@/entities/gridTables/slices/planningShiftTablesSlice'
import { updatePlanningShiftTableState } from '@/entities/gridTables/thunks/updatePlanningShiftTableState'
import { fetchScenarios } from '@/entities/schedules'
import { optimiseShift } from '@/entities/schedules/thunks/optimiseShift'
import { showShiftOnMap } from '@/entities/widgetWindows/thunks/showShiftOnMap'
import { showShiftsOnGantt } from '@/entities/widgetWindows/thunks/showShiftsOnGantt'
import { MosaicAdditionalToolbar } from '@/shared/components'
import { MosaicToolbarMenuItem } from '@/shared/components/MosaicAdditionalToolbar/models/MosaicToolbarMenuItem'
import { useAppDispatch } from '@/shared/store'
import { faArrowDown19 } from '@fortawesome/pro-light-svg-icons'
import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons'

import { usePlanningShiftTableContext } from './PlanningShiftTableContext'

export type PlanningShiftWindowToolbarProps = {
  //
}

export const PlanningShiftWindowToolbar: React.FC<PlanningShiftWindowToolbarProps> = () => {
  const { shiftId, scenarioId } = usePlanningShiftTableContext()
  const dispatch = useAppDispatch()

  const setShiftLoadingState = (loadingState: boolean) => {
    // Set loading state
    dispatch(setPlanningShiftTableLoading({ id: shiftId, isLoading: loadingState }))
  }

  const onResequence = async () => {
    setShiftLoadingState(true)
    await dispatch(optimiseShift({ shiftId }))
    await dispatch(fetchScenarios({ scenarioIds: [scenarioId] }))
    await dispatch(updatePlanningShiftTableState({ shiftId: shiftId }))
    setShiftLoadingState(false)
  }

  const onShowOnMap = () => {
    dispatch(showShiftOnMap({ shiftId }))
  }

  const onShowOnGantt = () => {
    dispatch(showShiftsOnGantt({ shiftIds: [shiftId] }))
  }

  const toolbarMenuItems: MosaicToolbarMenuItem[] = [
    { type: 'actionItem', icon: faArrowDown19, label: 'Resequence', onClick: onResequence },
    { type: 'actionItem', icon: faArrowUpRightFromSquare, label: 'Show on map', onClick: onShowOnMap },
    { type: 'actionItem', icon: faArrowUpRightFromSquare, label: 'Show on gantt', onClick: onShowOnGantt },
  ]

  return (
    <MosaicAdditionalToolbar
      toolbarMenuItems={toolbarMenuItems}
      averageMenuItemWidth={120}
    />
  )
}
